import React from 'react';
import classes from '../Modal.scss';
import { scoreRearrange } from '../utils';
import QuestionOption from './QuestionOption';
import { Question, QuestionSetProps } from '../types.d';

const QuestionSet = ({
  questions, scores, onScoreChange, setScores,
}: QuestionSetProps): React.ReactElement => {
  const setScoreValue = (qScore: number, question: Question): void => {
    const newData = scoreRearrange(scores, question?.questionId, qScore);
    onScoreChange(newData);
    setScores(newData);
  };

  const getOptionLabel = (question: Question, value: number): string | number => (
    (question?.options ?? []).find((q) => q.value === value)?.option ?? ''
  );

  const getScoreOptions = (question: Question): React.ReactElement => {
    const min = Number(question?.scoreMin);
    const max = Number(question?.scoreMax);
    const scoreOptions: React.ReactElement[] = [];

    for (let qScore = min; qScore <= max; qScore += 1) {
      scoreOptions.push(
        <QuestionOption
          key={qScore}
          onClick={() => setScoreValue(qScore, question)}
          isActive={scores?.find((s) => s.id === question?.questionId)?.score === qScore}
          label={getOptionLabel(question, qScore)}
        />,
      );
    }
    return <div className={classes.OptionGroup}>{scoreOptions}</div>;
  };

  const getQuestionSet = (): React.ReactElement[] => (questions ?? []).map((question: Question) => (
    <div key={question?.questionId} className={classes.QuestionArea}>
      <div className={classes.QuestionArea__Question_V3}>
        <p>
          Rate this technician&apos;s overall service compared to the expectations stated in the work order
        </p>
      </div>
      <div className={classes.QuestionArea__Score_V3}>{getScoreOptions(question)}</div>
    </div>
  ));

  return <>{getQuestionSet()}</>;
};

export default QuestionSet;
